import React, { Fragment } from 'react';
import Box from 'components/elements/Box';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';
import times from 'lodash.times';
import styled from 'styled-components/macro';

const Loader = styled(ContentLoader)`
  width: 100%;
  max-width: 100%;
`;

const BreadcrumbLoader: React.FC<{ isMobile: boolean }> = ({ isMobile }) => {
  const count = isMobile ? 1 : 3;

  return (
    <Box opacity={0.1}>
      <Loader width={300} height={60} uniquekey="BreadcrumbSkeleton">
        {times(count, (idx) => (
          <Fragment key={`event-skeleton-${idx}`}>
            <rect width="80" height="30" x={20 + 100 * idx} y={15} />
          </Fragment>
        ))}
      </Loader>
    </Box>
  );
};

export default BreadcrumbLoader;
